import { httpGatewayService, httpService } from "@/modules/common/services";
import {postQuery} from "@/modules/common/utils";

const baseRoute = 'business/docuforms';
const activityRoute = 'v1/activities';
const templateRoute = 'v1/templates';
const relationsRoute = 'v1/relations';

const getList = async (options = {}) => {
  try {
    const {top_hits} = await httpService.get('search/search_docuforms', options);
    const docuforms = top_hits.docuforms_activity ? top_hits.docuforms_activity : [];
    return {docuforms};
  } catch (error) {
    return {error};
  }
}

const getFilteredList = async (options = {}) => {
  const {data, errors} = await httpGatewayService.get(`${baseRoute}/${activityRoute}`, options);

  if (errors) {
    return {errors};
  } else {
    return {docuforms: data.activities};
  }
}

const getActivity = async (uid) => {
  const {data, errors} = await httpGatewayService.get(`${baseRoute}/${activityRoute}/${uid}`);

  if (errors) {
    return {errors};
  } else {
    return data.activity;
  }
}

const getTemplate = async (uid) => {
  const {data, errors} = await httpGatewayService.get(`${baseRoute}/${templateRoute}/${uid}`);

  if (errors) {
    return {errors};
  } else {
    return data.template;
  }
}

const setAsPublic = async (uid) => {
  const {data, errors} = await httpGatewayService.put(`${baseRoute}/${templateRoute}/${uid}/privacy_update`, {file_privacy: "Public"});

  if (errors) {
    return {errors};
  } else {
    return data.template;
  }
}

const shareItem = async (uid, shared_with_email) => {
  const res = await httpService.post(`documents/${uid}/share_with_client`, {shared_with_email: shared_with_email});
  if (res.error) {
    return res.error
  }

  return res;
}

const deleteItem = async (uid) => {
  const res = await httpGatewayService.remove(`${baseRoute}/${activityRoute}/${uid}`);
  if (res.error) {
    return res.error
  }

  return res;
}

const submitDocuments = async (params) => {
  let res;

  try {
    res = await postQuery('documents', params);
  }
  catch (error) {
    res = {error: error.errors.message || error.errors.error, status: error.errors.status};
    console.error(res.error);
  }

  return res;
}

const getRelations = async (entityType, entityId) => {
  const params = {
    'filter[entity_type]': entityType,
    'filter[entity_uid]': entityId
  }
  const {data, errors} = await httpGatewayService.get(`${baseRoute}/${relationsRoute}`, params);
  if (errors) {
    return {errors};
  } else {
    return {relations: data.relations};
  }
}

const attachDocument = async (entityType, entityId, documentId) => {
  const newRelation = { relation:
      { 'entity_type': entityType,
      'entity_uid': entityId,
      'activity_uid': documentId,}
  };
  const {data, errors} = await httpGatewayService.post(`${baseRoute}/${relationsRoute}`, newRelation);
  if (errors) {
    return {errors};
  }
}
const detachDocument = async (relation_id) => {
  const {data, errors} = await httpGatewayService.remove(`${baseRoute}/${relationsRoute}/${relation_id}`);
  if (errors) {
    return {errors};
  }
}

const getTemplates = async (page, per_page) => {
  const res = await httpService.get('file_records', {templates_only: true, page, per_page});
  if (res.error) {
    return res.error
  }
  return res;
}

export default {
  getList,
  getFilteredList,
  getActivity,
  getRelations,
  attachDocument,
  detachDocument,
  shareItem,
  deleteItem,
  getTemplates,
  submitDocuments,
  getTemplate,
  setAsPublic
}
